module.exports = __webpack_public_path__ + "img/Anthony.67b57076.png";